<template>
    <div class="clothes-list-item-box">
        <!-- 图片 -->
        <router-link 
            :to="{ 
                name: 'clothesDetail', 
                query: { id: itemData.goods_id }
            }"
            class="clothes-list-item-pic">
            <el-image
                :src="itemData.goods_img"
                fit="cover"
                lazy
                class="clothes-list-item-pic-box">
                <!-- 加载中样式 -->
                <template v-slot:placeholder>
                    <div class="image-slot">
                        <i class="el-icon-loading"></i>
                    </div>
                </template>
                <!-- 加载失败样式 -->
                <template v-slot:error>
                    <div class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </template>
            </el-image>
        </router-link>
        <!-- 文本 -->
        <div class="clothes-list-item-text">
            <!-- 标签 -->
            <div class="clothes-list-item-text-tag">
                <span v-for="item in itemData.tag"
                    :key="item.id">
                    {{item}}
                </span>
            </div>
            <!-- 标题 -->
            <router-link 
                :to="{ 
                    name: 'clothesDetail', 
                    query: { id: itemData.goods_id }
                }"
                class="clothes-list-item-text-title">
                {{itemData.goods_name}}
            </router-link>
            <!-- 其它 -->
            <div class="clothes-list-item-text-other">
                <!-- 价格 -->
                <div class="clothes-list-item-text-price">
                    <span>{{itemData.price}}</span>
                    <span>元/天</span>
                </div>
                <!-- 立即预定 -->
                <router-link :to="{ 
                        name: 'clothesDetail', 
                        query: { id: itemData.goods_id }
                    }"
                    class="clothes-list-item-text-reserve">
                    立即预定
                    <i class="el-icon-d-arrow-right"></i>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ "itemData" ]
}
</script>

<style scoped>
/* 组件容器 */
.clothes-list-item-box{
    border-radius: 15px;
    overflow: hidden;
    background-color: #fff;
}
/* 图片 */
.clothes-list-item-pic{
    position: relative;
    display: block;
    width: 100%;
    /* background-color: #F2F6FC; */
    /* border-bottom: 1px solid #F2F6FC; */
}
.clothes-list-item-pic::before{
    display: block;
    content: "";
    padding-top: 100%;
}
.clothes-list-item-pic-box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
/* 文本 */
.clothes-list-item-text{
    padding: 15px;
}
/* 标签 */
.clothes-list-item-text-tag>span{
    display: inline-block;
    vertical-align: middle;
    padding: 0 10px;
    border-radius: 15px;
    color: #fff;
    background-color: #E6A23C;
}
.clothes-list-item-text-tag>span+span{
    margin-left: 5px;
}
/* 标题 */
.clothes-list-item-text-title{
    display: block;
    width: 100%;
    padding: 10px 0;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #303133;
}
.clothes-list-item-text-title:hover{
    color: #8d9afc;
}
/* 价格 */
.clothes-list-item-text-price{
    display: inline-block;
    vertical-align: middle;
}
.clothes-list-item-text-price>span:first-child{
    margin-right: 3px;
    font-size: 16px;
    font-weight: bold;
    color: #E6A23C;
}
.clothes-list-item-text-price>span:last-child{
    color: #C0C4CC
}
/* 立即预定 */
.clothes-list-item-text-reserve{
    float: right;
    color: #8d9afc
}
</style>